export default "__VITE_ASSET__Di9OASk6__"